import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
	fetchAllCommitteeMeetings, fetchPastMeetings, switchPage, setMeetingFocus,
	filterByCommittee, setMeetingFilter
} from '../actions';
import MeetingTile from './meeting-tile';
import Pagination from './pagination';
import FilterByCommittee from './filter-committee';
import Loading from './loading-component';
class MeetingsPage extends Component {

	constructor( props ) {
		super( props );
		let current_tab = 'Upcoming Meetings';
		this.meetingsPerPage = 6;
		this.state = {
			current_tab   : current_tab,
			show_filter   : false,
			current_page  : 1,
			filter_keyword: '',
			meeting_pushed: false
		};
	}

	componentWillMount() {
		if ( Object.keys( this.props.allMeetings ).length === 0 ) {
			this.props.fetchAllCommitteeMeetings( this.props.meetingFilter );
		}
	}

	componentDidUpdate( prevProps ) {
		if ( this.props.meetingFilter !== prevProps.meetingFilter ) {
			this.props.fetchAllCommitteeMeetings( this.props.meetingFilter, 0, false );
		}
	}

	getTabs( upcomingMeetings, pastMeetings ) {
		let tabs = [ 'Upcoming Meetings', 'Past Meetings' ];
		let htmlTabs = tabs.map( tab => {
			let activeTab = (this.state.current_tab === tab
			                ) ? 'active' : '';
			return (
				<li name={tab} role="tab" className={ activeTab } onClick={ this.switchTab.bind( this, tab ) } type="button">{ tab } ({ tab === 'Upcoming Meetings'
					? upcomingMeetings
					: pastMeetings })</li>
			);
		} );

		return (<div className="container">
			<ul className="nav nav-tabs ">
				{ htmlTabs }
			</ul>
		</div>);
	}

	switchTab( tabName, reset_meeting_pushed = true ) {
		this.props.switchPage( 'meetings', 1 );
		let newState = this.state;
		newState.current_tab = tabName;
		if ( reset_meeting_pushed ) {
			this.setMeetingPushed( false );
		}
		this.setState( newState );

	}

	handleSearch( event ) {
		let newState = this.state;
		newState.filter_keyword = event.target.value;
		this.setState( newState );
	}

	clearFilters() {
		this.props.filterByCommittee( '' );
		this.props.setMeetingFilter( 'committee', '' );
	}

	getFilterOptions() {
		return (<div className="filter-container container">
				<FilterByCommittee />
				<button type="button" className="text-button text-button-black remove-filter-button" onClick={ this.clearFilters.bind( this ) } name="Clear all search filters">
					<i className="fa-regular fa-circle-xmark"></i>
						Clear All
					</button>
				{ /*<input type="search"*/ }
				{ /*value={ this.state.filter_keyword }*/ }
				{ /*onChange={ this.handleSearch.bind( this ) }*/ }
				{ /*className="form-control form-filter-keyword col-xs-12 col-md-4"*/ }
				{ /*id="committee-inner-page-search"*/ }
				{ /*placeholder="Filter by keyword" />*/ }

			</div>
		);
	}

	//TODO will use these functions later once a more optimized solution for searching past meetings is available
	//	filterUpcomingMeetings( meetings ) {
	//		let newMeetings = meetings.filter( meeting => meeting.type === 'upcoming' || meeting.type === 'ongoing' );
	//		if(this.state.filter_keyword === ''){
	//			return newMeetings
	// 		} else{
	//			return this.filterMeetingsByKeyword(newMeetings);
	//		}
	//	}
	//
	//TODO will use these functions later once a more optimized solution for searching past meetings is available
	//	filterMeetingsByKeyword( meetings ) {
	//		let keyword = this.state.filter_keyword;
	//		keyword = keyword.toLowerCase();
	//
	//		return meetings.filter( meeting => {
	//			let meeting_id = meeting.ID;
	//			let end_time = meeting.endtime.toLowerCase().includes( keyword );
	//			let start_date = meeting.nice_date.toLowerCase()
	//			                        .includes( keyword );
	//            let dial_in =''.includes(keyword);
	//			let dial_in_code = ''.includes(keyword);
	//			let online_meeting_information = (typeof meeting.online_meeting_information !== 'undefined') ? meeting.online_meeting_information.toLowerCase()
	//			                                        .includes( keyword ) : false;
	//			let meeting_documents = (typeof this.props.meetingDocuments[ meeting_id ] !== 'undefined'
	//			                        )
	//				? this.props.meetingDocuments[ meeting_id ]
	//				: [];
	//			let main_committee = findCommittee( this.props.committees, meeting.main_committee );
	//			main_committee = main_committee.title.toLowerCase().includes(keyword);
	//
	//			let agenda_info = findAgenda( meeting, meeting_documents );
	//			let agenda = agenda_info.agenda.toLowerCase().includes( keyword );
	//			let agenda_document = agenda_info.agenda_document;			//todo, do for secondary committees
	//			return (end_time || start_date || dial_in || dial_in_code || online_meeting_information || main_committee || agenda
	//			);
	//		} );
	//	}

	goToNextPage( page ) {
		let subtractPage = (page === 1
		                   ) ? 0 : 1;
		let min = ((page - subtractPage
		           ) * ((subtractPage === 0 ? 0 : 6
				)
		           )
		);
		this.setMeetingPushed( false );
		this.props.fetchPastMeetings( this.props.meetingFilter, min, true );
	}

	getPagination( upcomingMeetingsLength, pastMeetingsLength ) {
		if ( this.isUpComingMeetingTab() ) {
			return (
				<Pagination pageName={ 'meetings' } itemsPerPage={ 6 } itemsLength={ upcomingMeetingsLength } />
			);
		} else {
			return (
				<Pagination pageName={ 'meetings' } itemsPerPage={ 6 } itemsLength={ pastMeetingsLength } onClickFunc={ this.goToNextPage.bind( this ) } />
			);
		}
	}

	setMeetingPushed( pushed ) {
		let newState = this.state;
		newState.meeting_pushed = pushed;
		this.setState( newState );
		if ( this.props.meetingFocus !== '' && pushed === false ) {
			this.props.setMeetingFocus( '' );
		}
	}

	getUpcomingMeetings() {
		return (typeof this.props.allMeetings.upcoming_meetings !== 'undefined'
		       ) ? this.props.allMeetings.upcoming_meetings : [];
	}

	getPastMeetings() {
		return (typeof this.props.allMeetings.past_meetings !== 'undefined'
		       ) ? this.props.allMeetings.past_meetings : [];
	}

	getMeetingsToRender() {
		let meetings = [];
		let currentMeetings = this.isUpComingMeetingTab()
			? this.getUpcomingMeetings()
			: this.getPastMeetings();

		if ( this.props.meetingsLoading ) {
			for ( let i = 0; i < 6; i++ ) {
				meetings.push( <Loading height={ 200 } width={ '100%' } /> );
			}
			return meetings;
		}
		meetings = currentMeetings.map( meeting =>
			                                <MeetingTile meeting={ meeting } /> );

		if ( this.props.meetingFocus !== '' ) {
			if ( this.state.meeting_pushed === false ) {
				this.setMeetingPushed( true );
			}
			let focused_meeting = this.props.meetingFocus;
			let onRightTab = true;
			if ( (focused_meeting.type === 'past'
			     ) && this.isUpComingMeetingTab() ) {
				onRightTab = false;
				this.switchTab( 'Past Meetings', false );
			} else if ( (focused_meeting.type === 'upcoming' || focused_meeting.type === 'ongoing'
			            ) && !this.isUpComingMeetingTab() ) {
				onRightTab = false;
				this.switchTab( 'Upcoming Meetings', false );
			}
			if ( onRightTab && this.state.meeting_pushed ) {
				meetings.unshift(
					<MeetingTile meeting={ focused_meeting } focus={ true } /> );
			}
		}
		return meetings;

	}

	isUpComingMeetingTab() {
		return (this.state.current_tab === 'Upcoming Meetings'
		);
	}

	render() {

		//get meetings.
		const meetings = this.getMeetingsToRender();
		//meetings length comes from API request.
		const totalUpcomingMeetingsLength = (typeof this.props.allMeetings.total_upcoming_meetings !== 'undefined'
		                                    )
			? this.props.allMeetings.total_upcoming_meetings
			: 0;
		const totalPastMeetingsLength = (typeof this.props.allMeetings.total_past_meetings !== 'undefined'
		                                )
			? this.props.allMeetings.total_past_meetings
			: 0;

		let meetingsHtml = '';
		if ( meetings.length <= 0 ) {
			meetingsHtml = (<div className="information-banner">
					<span className="glyphicon glyphicon-info-sign" />
					<p>You do not have any upcoming meetings yet.</p>
				</div>
			);
		} else {
			const currentPage = (typeof this.props.pagination.meetings === 'undefined'
			                    ) ? 1 : this.props.pagination.meetings;
			const index = (currentPage === 1
			              ) ? 0 : ((currentPage - 1
			                       ) * this.meetingsPerPage
			                      );
			meetingsHtml = this.isUpComingMeetingTab()
				? meetings.slice( index, index + this.meetingsPerPage )
				: meetings;
		}
		return (
			<div className="overview-container">
				<div className="tab-filter-container">
					{ this.getTabs( totalUpcomingMeetingsLength, totalPastMeetingsLength ) }
					{ this.getFilterOptions() }
				</div>
				<div className="container">
					{ meetingsHtml }
					{ this.getPagination( totalUpcomingMeetingsLength, totalPastMeetingsLength ) }
				</div>
			</div>
		);
	}

}

function mapStateToProps( { allMeetings, committees, pagination, meetingDocuments, meetingFilter, meetingFocus, meetingsLoading } ) {
	return {
		allMeetings,
		committees,
		pagination,
		meetingDocuments,
		meetingFilter,
		meetingFocus,
		meetingsLoading
	};
}

export default connect( mapStateToProps, {
	fetchAllCommitteeMeetings,
	fetchPastMeetings,
	switchPage,
	setMeetingFocus,
	filterByCommittee,
	setMeetingFilter
} )( MeetingsPage );